<template>
  <div>
    <el-upload class="upload-demo" drag :action="action" :headers="{ token: token }" name="file" multiple :on-success="handleAvatarSuccess"  :before-upload="beforeAvatarUpload"  :show-file-list="false">
         <i class="el-icon-upload"></i>
         <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
    </el-upload>
    <div v-for="(item, index) in imgUrl" :key="index" class="img-dd">
      <el-image style="width: 100px; height: 100px" :initial-index="index" :src="item"  :preview-src-list="imgUrl" fit="cover"></el-image>
      <span class="del" @click="del(index)">删除</span>
    </div>
    <div class="el-upload__tip" style="margin-top: 0px;" slot="tip">只能上传jpg/png文件，且不超过{{this.size}}MB</div>
  </div>
</template>

<script>
import { upUrlApi } from '@/http/api.js'
export default {
  props: {
    revImgurl: []
  },
  data() {
    return {
      action: upUrlApi,
      token: '',
      imgUrl: [],
      size:50
    }
  },
  mounted() {
    this.token = localStorage.getItem('token');
    this.imgUrl = this.revImgurl;
    console.log('-0---', this.imgUrl)
  },
  methods: {
    del(index){
      this.imgUrl = this.imgUrl.filter((a, i) => i != index);
      console.log('删除', this.imgUrl)
      this.$emit('ok', this.imgUrl)
    },
    
    // 上传缩略图
    handleAvatarSuccess(res, file) {
      if(file.response.code === 1){
        this.imgUrl = this.imgUrl.concat(file.response.data.url);
        console.log('单图', file, this.imgUrl)
        this.$emit('ok', this.imgUrl)
      }else{
        this.$message.error('图片上传失败');
      }
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < this.size;
  
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 jpg、jpeg、png 格式!');
      }
      if (!isLt2M) {
        this.$message.error(`上传头像图片大小不能超过 ${this.size}MB!`);
      }
      return isJPG && isLt2M;
    },
  },
}
</script>

<style lang="scss" scoped>
.del{position: absolute; width: 100%; left: 0; bottom: 0; background-color: rgba(0,0,0,0.5); color: #fff; line-height: 1; display: block; cursor: pointer; text-align: center; padding: 4px 0; text-align: center;}
.img-dd{position: relative;width: 100px; height: 100px; margin-right: 10px;}
</style>